export default __webpack_public_path__ + "static/media/33t.ec085574.jpg";